import {css} from '@emotion/react'
import {Button} from 'antd'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

const cssToolBar = css({
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    padding: 8,
})

export default function ToolBar({items, selectedKeys, onUpgrade, ...props}) {
    const map = useMapContext()

    const upgrade = async items => {
        await runAsync(
            () => http.post(
                '/moduleReference/batchUpgradeCallModule',

                items.map(
                    ({
                        referer: {
                            bizNodeType: moduleBizNodeType,
                            pkid: moduleId,
                            sVer: moduleSVer,
                        },

                        referred: {
                            bizNodeType: calleeBizNodeType,
                            pkid: calleeModuleId,
                            rev: calleeRev,
                        },
                    }) => ({
                        calleeBizNodeType,
                        calleeModuleId,
                        calleeRev,
                        moduleBizNodeType,
                        moduleId,
                        moduleSVer,
                    })
                )
            ),

            {action: '升级制品'}
        )

        await runAsync(
            () => map.refreshMap(),
            {action: '重新分析'}
        )
    }

    const handleClickUpgrade = () => {
        const itemMap = new Map(
            items.map(e => [e.key, e])
        )

        const selectedItems = [...selectedKeys].map(key => itemMap.get(key))
        upgrade(selectedItems)
    }

    const handleClickUpgradeAll = () => {
        const upgradableItems = items.filter(
            e => e.referer.stsCode === 'RLS'
        )

        upgrade(upgradableItems)
    }

    return (
        <div
            css={cssToolBar}
            {...props}
        >
            <Button
                disabled={0 === selectedKeys.size}
                size="small"
                onClick={handleClickUpgrade}
            >
                升级
            </Button>

            <Button
                disabled={0 === items.length}
                size="small"
                onClick={handleClickUpgradeAll}
            >
                全部升级
            </Button>
        </div>
    )
}
